import * as yup from 'yup';

// Data-extension column prefixes. Every prefixed key below MUST match the DE
// column name verbatim — do not "fix" casing or spelling without confirming
// against the data extension.
const CAMPAIGN_PREFIX = 'american_eagle_lamine_yamal_sign_up_form_2026_';
const MASTER_OPT_IN = 'master_american_eagle_opt_in';

// -----------------------------------------------------------------------------
// Validation schema
// -----------------------------------------------------------------------------

export const alertsSignupSchema = yup.object().shape({
  first_name: yup.string().trim().required('Required'),
  last_name: yup.string().trim().required('Required'),
  email: yup.string().trim().email('Enter a valid email address').required('Required'),
  // English-derived snake_case slug from `buildCountryOptions` (lib/countries.ts).
  country_of_residence: yup.string().trim().required('Required'),
  // The consent checkbox bundles drop alerts + AE marketing; it must be ticked.
  marketing_optin: yup
    .boolean()
    .oneOf([true], 'We need your permission to email you')
    .required('We need your permission to email you'),
});

export type AlertsSignupValues = yup.InferType<typeof alertsSignupSchema>;

export const ALERTS_SIGNUP_DEFAULTS: AlertsSignupValues = {
  first_name: '',
  last_name: '',
  email: '',
  country_of_residence: '',
  marketing_optin: false as true,
};

// -----------------------------------------------------------------------------
// Data-extension mappings
// -----------------------------------------------------------------------------

/**
 * Campaign sign-up DE. Only the six columns this form feeds — no UTM (persisted
 * on `Session.utmParams` instead), no locale (master DE only).
 */
export function getSignupCampaignMapping(values: AlertsSignupValues) {
  return {
    first_name: values.first_name,
    last_name: values.last_name,
    email: values.email,
    country_of_residence: values.country_of_residence,
    [`${CAMPAIGN_PREFIX}opt_in`]: Boolean(values.marketing_optin),
    [`${CAMPAIGN_PREFIX}entry`]: true,
  };
}

/**
 * Master marketing DE — only the columns this form needs. The unused master
 * columns (`date_of_birth`, `gender`, `postcode`, all survey fields) are not
 * sent.
 */
export function getSignupMasterMapping(values: AlertsSignupValues, locale?: string) {
  return {
    first_name: values.first_name,
    last_name: values.last_name,
    email: values.email,
    country_of_residence: values.country_of_residence,
    locale: locale ?? '',
    [MASTER_OPT_IN]: Boolean(values.marketing_optin),
  };
}
